import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromNgrxRouter from '@ngrx/router-store';
import * as fromRouter from '@fc-store/reducers/router.reducer';

export const getRouterState =
  createFeatureSelector<
    fromNgrxRouter.RouterReducerState<fromRouter.RouterState>
  >('router');
export const selectRouteParams = createSelector(
  getRouterState,
  (state) => (state && state.state && state.state.params) || {},
);

export const selectRouteUrl = createSelector(
  getRouterState,
  (state) => (state && state.state && state.state.url) || '',
);

export const selectRouteQueryParams = createSelector(
  getRouterState,
  (state) => (state && state.state && state.state.queryParams) || {},
);

export const selectRouteData = createSelector(
  getRouterState,
  (state) => (state && state.state && state.state.data) || {},
);

export const selectCombinedRouteParams = createSelector(
  selectRouteParams,
  selectRouteData,
  (params, paramsData) => {
    return { params, paramsData };
  },
);

export const selectRouterParam = (paramName: string) =>
  createSelector(selectRouteParams, (params) => params[paramName]);

export const selectRouterQueryParam = (queryParamName: string) =>
  createSelector(
    selectRouteQueryParams,
    (queryParams) => queryParams[queryParamName],
  );

export const selectRouterParamData = (paramDataName: string) =>
  createSelector(selectRouteData, (params) => params[paramDataName]);
